import { render } from "./CreateNotification.vue?vue&type=template&id=00543c93"
import script from "./CreateNotification.vue?vue&type=script&lang=js"
export * from "./CreateNotification.vue?vue&type=script&lang=js"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__